import axios from "axios";
import cookie from "cookie";
import { NonceToken } from "../NonceToken";

const AUTH_COOKIE = "rememberme";
export const AUTO_LOGIN_COOKIE = "pottsalat_autologin";

const COOKIE_EXPIRATION_TIME = 60 * 60 * 24 * 2; // TWO DAYS
export const API_URL = reactConfig.url || "";

export let nonceToken = new NonceToken();

/**
 * Returns Auth Cookie value
 * @returns {string | undefined} token
 */
export const getAuthCookie = (cookieName = AUTH_COOKIE) => {
    const cookies = cookie.parse(document.cookie);
    return cookies[cookieName];
};

/**
 * Saves token to a cookie.
 * If stay signed the cookie remains for 2 days
 * Else it expires with session
 *
 * @param {bool} staySigned
 * @param {string} token
 * @returns
 */
export const setAuthCookie = (staySigned, token) => {
    const options = {
        sameSite: true,
        path: "/",
    };

    if (staySigned) {
        options.maxAge = COOKIE_EXPIRATION_TIME;
    }

    document.cookie = cookie.serialize(AUTH_COOKIE, token, options);
};

export const removeAuthCookie = (cookieName = AUTH_COOKIE) => {
    const expire = {
        expires: new Date("December 17, 1995 03:24:00"), // somewhere in the past
        sameSite: true,
        path: "/",
    };
    document.cookie = cookie.serialize(cookieName, "", expire);
};

export const cartFetcher = (url) =>
    axios.get(url).then((res) => {
        if (res.headers && res.headers["x-wc-store-api-nonce"]) {
            nonceToken.setNonceToken(res.headers["x-wc-store-api-nonce"]);
        }
        return res.data;
    });

export const fetcher = (url) => axios.get(url).then((res) => res.data);

export const config = {
    headers: {
        Authorization: `Bearer ${getAuthCookie()}`,
    },
};

/**
 * Intercepts every outgoing request
 * and updates the Auth header if token exists
 */
axios.interceptors.request.use((config) => {
    const token = getAuthCookie();
    const { pottsalatId } = window.cookie.get();

    // Add "Pottsalat-UID" to every request.
    config.headers["Pottsalat-UID"] = pottsalatId;
    config.headers["Pottsalat-Source"] = window.location.href;

    //Add "Pottsalat-referrer" to every request
    config.headers["Pottsalat-Referrer"] = document.referrer;

    if (!token) {
        return config;
    }

    config.headers.Authorization = `Bearer ${token}`;

    return config;
});
